import { convertToDateDefault, findValueInArray } from 'js/library/utils/helpers';
import phoneMaskArray from './phoneMaskArray.json';

export const fetchUserData = async ({
  form,
  userPersistInfo,
  setUserInfo,
  setValuesForm,
  setEmailGetUser,
  setLoadingForm,
  setFiles,
  setFileImage,
}) => {
  const userInfo = userPersistInfo || {};
  const data = {
    contactList: [],
    documentList: [],
    optInList: [],
    addressList: [],
    otherBlocks: {},
  };
  const fields = [
    ...(form?.formFields || []).map((field) => ({ ...field, sectionKey: 'formfields' })),
    ...Object.entries(form?.otherBlocks || {}).flatMap(([sectionKey, block]) =>
      block?.active === true ? (block.fields || []).map((field) => ({ ...field, sectionKey })) : []
    ),
  ];
  const emails = [];
  fields.forEach((field) => {
    const { fieldName, fieldType, inputType: _, type, sectionKey } = field;
    const section =
      sectionKey === 'formfields' ? userInfo : userInfo.otherBlocks?.[sectionKey] || {};
    if (type === 'contactList') {
      const contact = findValueInArray(section.contactList || [], 'type', fieldName);
      if (contact) {
        const normalized = { ...contact };
        if (fieldType === 'cellPhone') {
          const digits = String(contact.value || '').replace(/\D/g, '');
          const mask =
            phoneMaskArray.find((item) => digits.startsWith(item.ddd.replace(/\D/g, ''))) ||
            phoneMaskArray[0];
          normalized.phone = digits.replace(mask.ddd.replace(/\D/g, ''), '');
          normalized.mask = mask;
        }
        data[sectionKey === 'formfields' ? 'contactList' : 'otherBlocks'] =
          sectionKey === 'formfields'
            ? [...data.contactList, normalized]
            : {
                ...data.otherBlocks,
                [sectionKey]: {
                  ...(data.otherBlocks[sectionKey] || {}),
                  contactList: [...(data.otherBlocks[sectionKey]?.contactList || []), normalized],
                },
              };
        if (fieldType === 'email') emails.push(contact.value);
      }
      return;
    }
    if (type === 'documentList') {
      const doc = findValueInArray(section.documentList || [], 'type', fieldName);
      if (doc)
        data[sectionKey === 'formfields' ? 'documentList' : 'otherBlocks'] =
          sectionKey === 'formfields'
            ? [...data.documentList, doc]
            : {
                ...data.otherBlocks,
                [sectionKey]: {
                  ...(data.otherBlocks[sectionKey] || {}),
                  documentList: [...(data.otherBlocks[sectionKey]?.documentList || []), doc],
                },
              };
      return;
    }
    const value = section[fieldName];
    const normalized =
      fieldType === 'date' && value ? convertToDateDefault(new Date(value)) : (value ?? '');
    if (sectionKey === 'formfields') data[fieldName] = normalized;
    else
      data.otherBlocks[sectionKey] = {
        ...(data.otherBlocks[sectionKey] || {}),
        [fieldName]: normalized,
      };
  });
  setUserInfo(userInfo);
  setValuesForm(data);
  setEmailGetUser(emails);
  setFiles({});
  setFileImage({});
  setLoadingForm(false);
};
